import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AggregatorFeatureFlagGuard } from '@core/guards/aggregator-feature-flag/aggregator-feature-flag.guard';
import { AggregatorFeatureFlag } from '@env/aggregator/aggregator.interface';

import { EmailCampaignMetricsReportComponent } from './components/canvas-metrics/canvas-metrics.component';
import { ContactsReportComponent } from './components/contacts/contacts.component';
import { OpportunitiesReportComponent } from './components/opportunities/opportunities.component';
import { RefixesReportComponent } from './components/refix/refixes.component';
import { ReportsLayoutComponent } from './views/layout/layout.component';
import { aggregator } from '@env/aggregator/aggregator';
import { Aggregator } from '@liberty-financial/agp-shared';

const routes: Routes = [
  {
    path: '',
    component: ReportsLayoutComponent,
    title: 'Reports',
    children: [
      {
        path: '',
        redirectTo: aggregator.name === Aggregator.MPM ? 'refixes' : 'contacts',
        pathMatch: 'full'
      },
      {
        path: 'contacts',
        component: ContactsReportComponent,
        canActivate: [AggregatorFeatureFlagGuard],
        title: 'Reports - Contacts',
        data: {
          aggregatorFeatureFlag: AggregatorFeatureFlag.ContactsReport
        }
      },
      {
        path: 'opportunities',
        component: OpportunitiesReportComponent,
        canActivate: [AggregatorFeatureFlagGuard],
        title: 'Reports - Opportunities',
        data: {
          aggregatorFeatureFlag: AggregatorFeatureFlag.OpportunitiesReport
        }
      },
      {
        path: 'refixes',
        component: RefixesReportComponent,
        canActivate: [AggregatorFeatureFlagGuard],
        title: 'Reports - Refixes',
        data: {
          aggregatorFeatureFlag: AggregatorFeatureFlag.RefixReport
        }
      },
      {
        path: 'email-campaign-metrics',
        component: EmailCampaignMetricsReportComponent,
        canActivate: [AggregatorFeatureFlagGuard],
        title: 'Reports - Email Campaign Metrics',
        data: {
          aggregatorFeatureFlag: AggregatorFeatureFlag.CanvasMetricsReport
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReportsRoutingModule {}
